import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import { useBrand } from "../context/BrandContext";

// COPPA-compliant legal pages, publicly reachable (no login) for app-store
// review and signup footers.

const Shell = ({ title, children }) => {
  const brand = useBrand();
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border px-6 py-4">
        <div className="max-w-3xl mx-auto flex items-center gap-3">
          <Link to="/" className="text-sm font-bold inline-flex items-center gap-1 text-muted-foreground hover:text-foreground"
            data-testid="legal-back-link">
            <ArrowLeft className="h-4 w-4" aria-hidden="true" /> {brand.platform_name}
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-10 space-y-4">
        <h1 className="text-3xl font-extrabold font-display flex items-center gap-2">
          <ShieldCheck className="h-7 w-7 text-secondary" aria-hidden="true" /> {title}
        </h1>
        <div className="space-y-4 text-sm leading-6 text-muted-foreground">{children}</div>
      </main>
    </div>
  );
};

const H = ({ children }) => <h2 className="text-base md:text-lg font-bold text-foreground pt-2">{children}</h2>;

export function PrivacyPage() {
  return (
    <Shell title="Privacy Policy">
      <p data-testid="privacy-content">We build for families, and children's privacy comes first.
        This policy explains what we collect, why, and the controls parents always have.</p>
      <H>Children's privacy (COPPA)</H>
      <p>Child profiles are created and consented to by a verified parent or guardian.
        We collect only what learning requires: a display name, age band, interests and practice results.
        We never collect a child's exact address, contact details or documents.</p>
      <H>Ephemeral media processing</H>
      <p>Worksheet photos, scratchpad images and voice recordings are processed in memory to produce
        scores and practice concepts, then discarded. Raw media files are never stored on our servers.</p>
      <H>Parent data controls</H>
      <p>From the Parent Dashboard you can view, export (JSON) or permanently delete your child's
        learning history with one click, and delete child profiles entirely.</p>
      <H>Payments</H>
      <p>All payments run through Stripe Checkout on Stripe's servers. Card numbers never touch our
        systems or database; we store only the subscription status Stripe reports back.</p>
      <H>Contact</H>
      <p>Questions or data requests: contact the account owner support address listed in your plan
        emails. We answer verified parent requests within 30 days.</p>
    </Shell>
  );
}

export function TermsPage() {
  return (
    <Shell title="Terms of Service">
      <p data-testid="terms-content">By using this app you agree to these terms.</p>
      <H>The service</H>
      <p>We provide speech, language and math practice tools for children, supervised and configured
        by their parent or guardian. Educational guidance is practice support, not medical or
        therapeutic advice; consult a licensed professional for clinical decisions.</p>
      <H>Accounts & subscriptions</H>
      <p>Parents manage the account, child profiles and plan. Subscriptions (Single Child, Family
        Bundle and legacy plans) renew monthly via Stripe and can be cancelled anytime; access lasts
        until the end of the paid period.</p>
      <H>Acceptable use</H>
      <p>No misuse, scraping, reverse engineering or attempts to access other families' data.
        External opportunity applications happen on the provider's official site — always review
        them yourself.</p>
      <H>Liability</H>
      <p>The service is provided as-is; to the maximum extent permitted by law our liability is
        limited to the fees paid in the last 12 months.</p>
    </Shell>
  );
}
